import type {Price} from '@/redux/v1/models';

import {config} from '@/config';
import {useSearchParams} from '@/modules/common/hooks/useSearchParams';
import {getDisplayPrice as getDisplayPriceFunction} from '@/modules/common/utils/price';

export const useDisplayPrice = () => {
  const [{rooms}] = useSearchParams();
  const {pricePerPerson} = config.global;

  const getDisplayPrice = (price: Price | null | undefined): Price | null =>
    getDisplayPriceFunction(price, rooms);

  return {
    isPricePerPerson: pricePerPerson && rooms?.length > 1,
    getDisplayPrice,
  };
};
